import React from "react";
import { python } from '@codemirror/lang-python';
import CodeMirror, { lineNumbers } from '@uiw/react-codemirror';
import { vscodeDark } from '@uiw/codemirror-theme-vscode';
import { FaPlayCircle, FaStopCircle } from "react-icons/fa";


const CodeViewerEditor = (props) => {
    const { code, isOnFocus = false, onChangeCode, isEditable = "true", cellIndex = -1, cellExecutionDetails, RunCodeCell, StopExecution, selectNextCodeCell } = props;
    console.log("Rendering codeblock ", cellIndex);

    const isExecuting = cellExecutionDetails ? cellExecutionDetails.isExecuting : false;
    const executionCount = cellExecutionDetails ? cellExecutionDetails.executionCount : null;
    // const executionCount = cell['execution_count'];
    const source = code;
    const [value, setValue] = React.useState("");
    const onChange = React.useCallback((val) => {
        setValue(val);
        onChangeCode(cellIndex, val);
    }, [onChangeCode]);

    React.useEffect(() => {
        if (Array.isArray(source)) {
            setValue(source.join(''));
        } else {
            setValue("");
        }
    }, [code, source])
    function classNames(...args) {
        return args.filter(Boolean).join(' ')
    }
    const handleKeyDown = (event) => {
        if (event.keyCode === 13 && event.shiftKey) { //13 is enter
            event.preventDefault();
            // Trigger the button element with a click
            RunCodeCell(cellIndex, value);
            selectNextCodeCell(cellIndex);
        }
    }
    return (<>
        <div className="cell-row">
            <pre className="cell-header source" style={{ "display": "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "flex-end" }}>
                {isExecuting && <button className="runcode-button" onClick={() => StopExecution()}><FaStopCircle className="icons-sizes-runcode" /></button>}
                {!isExecuting && <button className="runcode-button" onClick={() => { RunCodeCell(cellIndex, value) }}><FaPlayCircle className="icons-sizes-runcode" /></button>}
                {executionCount ? `[${executionCount}] ` : null}
            </pre>
            <div className={classNames("code-cell-css", "cell-content", isOnFocus && 'focused-code-div')}>
                <CodeMirror
                    readOnly={!isEditable}
                    editable={isEditable}
                    value={value}
                    theme={vscodeDark}
                    // highlightActiveLine={false}
                    extensions={[python(), lineNumbers()]}
                    onChange={onChange}
                    minHeight="50px"
                    onKeyDown={(e) => handleKeyDown(e)}
                    autoFocus={isOnFocus}
                />
            </div>
        </div>
    </>
    )
}

export default React.memo(CodeViewerEditor);